export interface ResetPasswordModel {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}
